import React from 'react';
import styled from 'styled-components';

import { FONT } from '../../styles/color';

const Text = styled.p`
    margin: 0;
    padding: 0;
    font-size: ${ props => props.$size || '16px' };
    font-weight: ${ props => props.$weight || '350' };
    font-family: Pretendard Variable;
    color: ${ props => props.$color || FONT.default };
    overflow: ${ props => props.$useEllipsis ? 'hidden' : 'visible' };
    text-overflow: ${ props => props.$useEllipsis ? 'ellipsis' : 'clip' };
    display: ${ props => props.$useEllipsis ? '-webkit-box' : 'block' };
    -webkit-line-clamp: ${ props => props.$useEllipsis ? '1' : 'none' };
    -webkit-box-orient: ${ props => props.$useEllipsis ? 'vertical' : 'none' };
`;

export function Light(props) {
  return (
    <Text
        $size={ props.size }
        $weight={ 300 }
        $color={ props.color } 
        $useEllipsis={ props.useEllipsis }
        style={ props.style }
    >{ props.children }</Text>
  );
}

export function Medium(props) {
  return (
    <Text
        $size={ props.size }
        $weight={ 450 }
        $color={ props.color } 
        $useEllipsis={ props.useEllipsis }
        style={ props.style }
    >{ props.children }</Text>
  );
}

export function SemiBold(props) {
  return (
    <Text
        $size={ props.size }
        $weight={ 650 }
        $color={ props.color } 
        $useEllipsis={ props.useEllipsis }
        style={ props.style }
    >{ props.children }</Text>
  );
}

export function Bold(props) {
  return (
    <Text
        $size={ props.size }
        $weight={ 750 }
        $color={ props.color } 
        $useEllipsis={ props.useEllipsis }
        style={ props.style }
    >{ props.children }</Text>
  );
}

export function ExtraBold(props) {
  return (
    <Text
        $size={ props.size }
        $weight={ 800 }
        $color={ props.color } 
        $useEllipsis={ props.useEllipsis }
        style={ props.style }
    >{ props.children }</Text>
  );
}